<template>
  <div>
    <div class="head">
      <div class="user-box">
        <div class="head-picture">
          <img :src="userInfo.headimgurl" alt="" />
        </div>
        <div class="name">{{ userInfo.nickname }}</div>
      </div>
    </div>
    <div class="menu">
      <div class="item-box">
        <van-cell is-link class="item"  @click="$router.push({name:'myOrders'})">
          <div slot="default" class="dis-flex flex-y-center">
            <div class="icon" style="background-color: #0078d7;">
              <img src="@/assets/user-menu-1.png" alt="" />
            </div>
            我的订单
          </div>
        </van-cell>
        <van-cell is-link class="item" @click="$router.push({name:'shoppingCartIndex'})">
          <div slot="default" class="dis-flex flex-y-center">
            <div class="icon" style="background-color: #ff0000;">
              <img src="@/assets/user-menu-2.png" alt="" />
            </div>
            我的购物车
          </div>
        </van-cell>
        <van-cell is-link class="item" @click="$router.push({name:'accountSetting'})">
          <div slot="default" class="dis-flex flex-y-center">
            <div class="icon" style="background-color: #59a0f7;">
              <img src="@/assets/user-menu-3.png" alt="" />
            </div>
            账号设置
          </div>
        </van-cell>
        <van-cell is-link class="item" @click="$router.push({name:'feedback'})">
          <div slot="default" class="dis-flex flex-y-center">
            <div class="icon" style="background-color: #f7921e;">
              <img src="@/assets/user-menu-4.png" alt="" />
            </div>
            帮助与反馈
          </div>
        </van-cell>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'index',
  data() {
    return {};
  },
  components: {},
  created() { 
  },
  mounted() { },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {},
  methods: {},
  destroyed() { },
};
</script>

<style scoped lang="scss">
.head {
  height: 150px;
  background: url(~@/assets/user-head-bg.jpg);
  overflow: hidden;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  position: relative;
  .user-box {
    text-align: center;
    .head-picture {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      overflow: hidden;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .name {
      color: #fff;
      font-size: 14px;
      margin-top: 10px;
    }
  }

  &::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.3);
  }
  .user-box {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    transform: translate(-50%, -50%);
  }
}
.menu {
  background: #fff;
  .item-box {
    padding: 0 10px;
    .item {
      padding: 7px 0;
      border-bottom: 1px solid rgba($color: #000000, $alpha: 0.15);
      .icon {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        position: relative;
        margin-right: 4px;
        img {
          width: 65%;
          height: 65%;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
}
</style>
